import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AssetlinksService } from 'src/app/services/assetlinks.service';
import { ForSaleCoupon, IndefiniteCoupon, ShopWithCoupons } from 'src/app/models/interfaces';
import { GisService } from 'src/app/services/gis.service';
import { LocationService } from 'src/app/services/location.service';
import { SwiperComponent } from 'swiper/angular';
import SwiperCore, { SwiperOptions, Virtual,Pagination,EffectCards,Scrollbar, EffectFlip  } from 'swiper';
// install Swiper modules
SwiperCore.use([Scrollbar]);

@Component({
  selector: 'app-shop-coupons-lane',
  templateUrl: './shop-coupons-lane.component.html',
  styleUrls: ['./shop-coupons-lane.component.scss'],
})
export class ShopCouponsLaneComponent  implements OnInit {
  @Input() shopWithCoupons:ShopWithCoupons
  @Input() cardHeight = '9em'
  @Output() onCouponSelectEmit:EventEmitter<IndefiniteCoupon|ForSaleCoupon> = new EventEmitter();
  kmFromUser:string;
  @ViewChild('swiper', { static: true }) swiper?: SwiperComponent;
  swiperConfig: SwiperOptions = {
    slidesPerView:1.5,
    centeredSlides:false,
    centeredSlidesBounds:true,
    scrollbar:false,
    flipEffect:{
      transformEl:'ion-card'
    }
  };
  constructor(
    public assetLinksService:AssetlinksService,
    private modalCtrl:ModalController,
    private gisService:GisService,
    private locationService:LocationService
  ) { 
  
  }

  ngOnInit() {
    if(this.shopWithCoupons && this.shopWithCoupons.coupons.length == 1){
      this.swiperConfig.slidesPerView = 'auto'
    }
  }

  couponSelected(coupon){
    this.onCouponSelectEmit.emit(coupon);
    console.log('emitted from ShopCouponsLaneComponent',coupon);
  }

  onSwiper(params) {
    const [swiper] = params;
    console.log(swiper);
  }
  
  onBeforeTransitionStart(params) {
    const [swiper, speed, internal] = params;
    console.log('beforeTransitionStart, speed: ' + speed);
  }
  
  onSlideChange() {
    console.log('slide change');
  }
  
  slideNext(){
    this.swiper.swiperRef.slideNext(500);
  }
  
  slidePrev(){
   this.swiper.swiperRef.slidePrev(500);
  }

}
